import React from "react";

export function stopPropagation(evt: React.UIEvent): void {
    evt.stopPropagation();
}

export function preventDefault(evt: React.UIEvent): void {
    evt.preventDefault();
}
